import clsx from "clsx";
import type { DealDetail } from "@edge/shared";
import { StatusDot } from "../shared/StatusDot";

interface BreadcrumbBarProps {
  detail: DealDetail | null;
  loading: boolean;
  onBack: () => void;
}

function formatAmount(n: number | null): string {
  if (n == null) return "—";
  if (n >= 1_000_000) {
    const m = n / 1_000_000;
    return `$${m % 1 === 0 ? m.toFixed(0) : m.toFixed(1)}M`;
  }
  return `$${Math.round(n / 1000)}K`;
}

function formatMonthDay(iso: string | null): string {
  if (!iso) return "TBD";
  const d = new Date(`${iso}T12:00:00Z`);
  return new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    month: "numeric",
    day: "2-digit",
  }).format(d);
}

export function BreadcrumbBar({ detail, loading, onBack }: BreadcrumbBarProps) {
  const name = detail?.name ?? (loading ? "LOADING…" : "—");
  return (
    <div className={clsx("crumb-bar", detail?.urgent && "crumb-urgent")}>
      <button className="back-btn" onClick={onBack}>
        ◂ HOME
      </button>
      <span className="crumb-divider">/</span>
      <span className="crumb-deal-name">{name.toUpperCase()}</span>
      {detail?.stage && (
        <span className="crumb-deal-stage">▸ {detail.stage.toUpperCase()}</span>
      )}

      {detail && (
        <>
          <div className="crumb-dots">
            <StatusDot info={detail.dots.watch} label="WTCH" />
            <StatusDot info={detail.dots.tsk} label="TSK" />
          </div>

          <div className="crumb-meta">
            <div className="crumb-meta-item">
              <span className="crumb-meta-label">LOAN</span>
              <span className="crumb-meta-value amount">
                {formatAmount(detail.amountRequested)}
              </span>
            </div>
            <div className="crumb-meta-item">
              <span className="crumb-meta-label">CLOSE</span>
              <span className="crumb-meta-value">{formatMonthDay(detail.closeDate)}</span>
            </div>
            {detail.daysSinceModified != null && (
              <div className="crumb-meta-item">
                <span className="crumb-meta-label">IDLE</span>
                <span className="crumb-meta-value">{detail.daysSinceModified}d</span>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
